import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class CobbledRoadTileEntity8 extends TileEntity {
	public static readonly frameName = FrameName.COBBLED_ROAD_8;
}

export default CobbledRoadTileEntity8;
